import { render, staticRenderFns } from "./createAccountBeneficario.vue?vue&type=template&id=12b5daa8&"
import script from "./createAccountBeneficario.vue?vue&type=script&lang=ts&"
export * from "./createAccountBeneficario.vue?vue&type=script&lang=ts&"
import style0 from "./createAccountBeneficario.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports